import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ROUTES } from './foc.routes';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';


//Components
import { Foc } from './components/main/foc.component';
import{ OfflineErrorBanner } from './components/offline-error-banner/offline-error-banner.component'
import { StudentBook } from './components/books/student-book/student-book.component';
import { BaseBook } from './components/books/base-book/base-book.component';
import { Toolbar } from './components/tools/toolbar/toolbar.component';
import { TipModal } from './components/tools/tip-modal/tip-modal.component';
import { AssignmentModal } from './components/tools/assignment-modal/assignment-modal.component';
import { ToastComponent } from './components/tools/toaster/toast.component';
import { ToastItemComponent } from './components/tools/toaster/toast-item.component';
import { Timer } from './components/tools/timer/timer.component';
import { ActivityLaunch } from './components/activity/activity-launch/activity-launch.component';
// import { ActivityView } from './components/activity/activity-view/activity-view.component';
import { SaveAlert } from './components/activity/save-alert/save-alert.component';

import { StudentBookResolver } from './services/student-book-resolver.service';
import { StudentBookService } from './services/student-book.service';
import { ImgBookService } from './services/img-book.service';
import { LoHotspot } from './components/tools/lo-hotspot/lo-hotspot.component';

import { GroupHelperService } from './services/groups-helper.service';
import { ProductTocService } from './services/product-toc.service';
import { ProductViewDataService } from './services/product-view-data.service';
import { ProductViewHelperService } from './services/product-view-helper.service';
import { LODBHelperService } from './services/lo-db-helper.service';

// import { ActivityViewResolverService } from './services/activity-view-resolver.service';
import { Notes } from './components/tools/notes/notes.component';
import { NotesDataService } from './services/notes-data.service';
import { LastPageDataService } from './services/last-page-data.service';
import { AppUnloadTrackerService } from './services/app-unload-tracker.service';
import { XAPIHelperService } from './services/xAPI-helper.service';
//Directives
import { IfDesktopAppDirective } from './directives/if-desktop-app.directive';

//Services
import { CustomTranslationLoader } from './../app/services/custom-translation-loader';
import { ImgBookHelperService } from './services/img-book-helper.service';
import { RouteNavigationService } from './services/route-navigation.service';
import { ToolsService } from './services/tools.service';
import { ModalService } from './services/modal.service';
import { DrawingToolsService } from './services/drawing-tools.service';
import { DrawingDataService } from './services/drawing-data.service';
import { DesktopEBookVMService } from 'modules/desktop/services/desktop-ebook-vm.service';
import { TrackUserService } from './services/track-user.service';
import { TabbingOrderService } from './services/tabbing-order.service';
// Pipes
import { SafePipe } from './pipes/safe.pipe';
import { ResultScreen } from './components/tools/result-screen/result-screen.component';
import { MediaPlayerComponent } from './components/media-player/media-player.component';


@NgModule({
    declarations: [
        Foc,
        StudentBook,
        MediaPlayerComponent,
        BaseBook,
        Toolbar,
        TipModal,
        AssignmentModal,
        Timer,
        IfDesktopAppDirective,
        SafePipe,
        LoHotspot,
        Notes,
        ActivityLaunch,
        ToastComponent,
        ToastItemComponent,
        // ActivityView,
        SaveAlert,
        OfflineErrorBanner,
        ResultScreen
    ],
    imports: [
        CommonModule,
        ROUTES,
        FormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslationLoader
            }
        })
    ],
    providers: [
        StudentBookResolver,
        StudentBookService,
        TabbingOrderService,
        ImgBookService,
        ImgBookHelperService,
        RouteNavigationService,
        ToolsService,
        ModalService,
        DrawingToolsService,
        GroupHelperService,
        ProductTocService,
        ProductViewDataService,
        ProductViewHelperService,
        LODBHelperService,
        // ActivityViewResolverService,
        NotesDataService,
        LastPageDataService,
        DrawingDataService,
        AppUnloadTrackerService,
        XAPIHelperService,
        DesktopEBookVMService,
        TrackUserService
    ]
})
export class FocModule {

}
